import React from 'react'
import bookingCreated from '../../assets/icons/booking_created.svg';
import bidStarted from '../../assets/icons/bis_started.svg';
import bidEnded from '../../assets/icons/bid_ended.svg';
import driverAssigned from '../../assets/icons/driver_assigned.svg';
import driverReassigned from '../../assets/icons/driver_reassigned.svg';
import driverReached from '../../assets/icons/driver_reached.svg';
import tripStarted from '../../assets/icons/trip_started.svg';
import tripCompleted from '../../assets/icons/trip_completed.svg';



const TimeLogIcons = ({timeLogType}) => {
    if(timeLogType=='Booking created'){
        return  <img src={bookingCreated} alt="Your SVG" />
    }else if(timeLogType=='Bid Started'){
        return  <img src={bidStarted} alt="Your SVG" />
    }else if(timeLogType=='Bid Ended'){
        return  <img src={bidEnded} alt="Your SVG" />
    }else if(timeLogType.includes('Booking manually assigned')){
        return  <img src={driverAssigned} alt="Your SVG" />
    }else if(timeLogType=='Booking created'){
        return  <img src={driverReassigned} alt="Your SVG" />
    }else if(timeLogType=='Driver has reached pickup location'){
        return  <img src={driverReached} alt="Your SVG" />
    }else if(timeLogType=='Trip started'){
        return  <img src={tripStarted} alt="Your SVG" />
    }else if(timeLogType.includes('Trip completed')){
        return  <img src={tripCompleted} alt="Your SVG" />
    }
    
  return <div className='activity-dot-secondary'></div>
}

export default TimeLogIcons